import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { CSAgentRoutePaths } from "../../constants/Routes";
import { useDispatch } from "react-redux";
import { logUserSessionActivities } from "../../actions/AdminPortal/UserActivityLogs";
import { LOCALSESSIONDATAKEYS, USER_ACTIVITY_LOGS } from "../../constants/AppConstants";
import { getLocalSessionData } from "../../utils/Authentication/handleUserSession";

const CSAgentRedirection = () => {
    const dispatch = useDispatch();
    const isSessionLogTriggered = getLocalSessionData(LOCALSESSIONDATAKEYS.USER_SESSION_ACTIVITY_LOGS);
    useEffect(() => {
        if(!isSessionLogTriggered){
            dispatch(logUserSessionActivities(USER_ACTIVITY_LOGS.LOGIN, 'LOGIN'));
        }
    }, [dispatch, isSessionLogTriggered])
    return(
        <Redirect to={CSAgentRoutePaths.CUSTOMER_SEARCH}/>
    )
}

export default CSAgentRedirection;